import { inject } from "@angular/core";
import { NavigationService } from "app/core/navigation/navigation.service";
import { Navigation } from "app/core/navigation/navigation.types";
import { MessagesService } from "app/layout/common/messages/messages.service";
import { NotificationsService } from "app/layout/common/notifications/notifications.service";
import { QuickChatService } from "app/layout/common/quick-chat/quick-chat.service";
import { ShortcutsService } from "app/layout/common/shortcuts/shortcuts.service";
import { catchError, forkJoin, of } from "rxjs";

const fallbackNavigation: Navigation = {
  compact: [],
  default: [
    {
      id: "overview",
      title: "Overview",
      type: "group",
      children: [
        {
          id: "company",
          title: "Company",
          type: "basic",
          icon: "heroicons_outline:building-office-2",
          link: "/company",
        },
        {
          id: "bookings",
          title: "Bookings",
          type: "basic",
          icon: "mat_outline:bar_chart",
          link: "/bookings",
        },
      ],
    },
  ],
  futuristic: [],
  horizontal: [],
};

export const initialDataResolver = () => {
  const messagesService = inject(MessagesService);
  const navigationService = inject(NavigationService);
  const notificationsService = inject(NotificationsService);
  const quickChatService = inject(QuickChatService);
  const shortcutsService = inject(ShortcutsService);

  // Fork join multiple API endpoint calls to wait all of them to finish
  return forkJoin({
    navigation: navigationService.get().pipe(
      catchError(() => {
        navigationService.navigation = fallbackNavigation;
        return of(fallbackNavigation);
      }),
    ),
    messages: messagesService.getAll().pipe(catchError(() => of([]))),
    notifications: notificationsService.getAll().pipe(catchError(() => of([]))),
    chats: quickChatService.getChats().pipe(catchError(() => of([]))),
    shortcuts: shortcutsService.getAll().pipe(catchError(() => of([]))),
  });
};
